import { FC } from 'react';
import { Tooltip as ReactTippy, TooltipProps as ReactTippyProps } from 'react-tippy';

type TooltipProps = ReactTippyProps & {
    children: React.ReactNode;
};
export const Tooltip: FC<TooltipProps> = ({ children, ...props }: TooltipProps) => {
    return (
        <ReactTippy theme="light" arrow={true} {...props}>
            {children}
        </ReactTippy>
    );
};
